import type { MessageCode } from '~/constants/MessageCode';
/**
 * クライアント側で発生したエラー
 */
export class ClientError extends Error {
  override name = 'ClientError';
  messageCode: MessageCode;
  displayId: string;

  constructor(messageCode: MessageCode, displayId: string) {
    super();
    this.messageCode = messageCode;
    this.displayId = displayId;
  }
}
